import { useSampleAccountsQuery } from '@/features/workspaces/hooks';

/**
 * Sample Workspace
 * interactive_demo_workspace / sample_workspace
 * Part of:
 * https://linear.app/customerio/project/sample-workspace-view-only-workspace-387ba35103c0/overview
 */

export const useSampleWorkspace = () => {
  const { data: sampleAccount } = useSampleAccountsQuery();
  const sampleAccountId = sampleAccount?.accountId ?? null;
  const sampleWorkspaceId = sampleAccount?.workspaceId ?? null;

  const isSampleWorkspace = (workspaceId: number | null | undefined) => {
    if (workspaceId == null) {
      return false;
    }

    return workspaceId === sampleWorkspaceId;
  };

  return {
    sampleAccountId,
    sampleWorkspaceId,
    isSampleWorkspace,
  };
};
